import { create } from 'zustand'
import { ResourceTitleModel } from "api/resource-model"

interface ResourceStore {
  record: ResourceTitleModel | null
  setResourceTitleData: (currentResourceTitleData: ResourceTitleModel) => void
  getResourceTitleData():ResourceTitleModel | null
}

export default create<ResourceStore>()((set,get) => ({
  record: null,
  setResourceTitleData: (record) =>set(() => ({ record })),
  getResourceTitleData:()=>get().record
}))

export type { ResourceStore }
